import React, { Component } from 'react';
import ConfigBusiness from '../../commons/config/ConfigBusiness.js';
import '../../assets/css/styles.css';

class Suspension extends Component {
    constructor(props) {
        super(props);
        this.state = { title: props.title, text: props.text }
        this.loginRandom = null;
    }

    getBrandedLogo(defaultFilename, visibilityConfigKey = null) {
        if (visibilityConfigKey) {
            const isVisible = ConfigBusiness.get(visibilityConfigKey);
            if (isVisible === "false") return null;
        }
        const clientSlug = ConfigBusiness.get("generales.clienteSlug");
        if (clientSlug && clientSlug !== "false" && clientSlug !== "default") {
            return `${process.env.PUBLIC_URL}/images/branding/${clientSlug}/${defaultFilename}`;
        }
        return `${process.env.PUBLIC_URL}/images/company/${defaultFilename}`;
    }

    componentDidMount () {
        document.body.className = 'vertical-layout vertical-menu 1-column menu-expanded blank-page blank-page';
        document.body.setAttribute('data-col', '1-column');
    }

    render() {
        if (!this.loginRandom) this.loginRandom = 1 + Math.floor((4 - 1) * Math.random());

        const logoAppSrc = this.getBrandedLogo("logo-login-app.png");
        const logoCompanySrc = this.getBrandedLogo("logo-login-company.png", "frontend.logos.company.visible");
        const logoPoweredBySrc = this.getBrandedLogo("logo-login-powered-by.png", "frontend.logos.poweredBy.visible");
        const versionLabel = process.env.REACT_APP_VERSION || "0.0.0";
        const shortVersion = versionLabel.split('-')[0];

        return (
            <div className="app-content content">
                <div className="content-wrapper">
                    <div className="content-body">
                        <video className="video-login-bg" autoPlay muted loop poster={process.env.PUBLIC_URL + "/images/images-login/image" + this.loginRandom + ".png"}>
                            <source src={process.env.PUBLIC_URL + "/images/videos-login/video" + this.loginRandom + ".mp4"} type="video/mp4" />
                        </video>
                        <section className="flexbox-container">
                            <div className="col-12 d-flex align-items-center justify-content-center">
                                <div className="col-11 col-sm-8 col-md-6 col-lg-4 p-0" style={{maxWidth: '400px'}}>
                                    <div className="card border-0 m-0" style={{borderRadius: '1rem', boxShadow: '0 15px 35px rgba(0,0,0,0.2)'}}>
                                        
                                        <div className="card-header border-0 text-center pb-0" style={{paddingTop: '2rem'}}>
                                            <img src={logoAppSrc} alt="App Logo" className="img-fluid center-block" style={{ maxHeight: '110px', objectFit: 'contain' }} onError={(e) => { e.target.onerror = null; e.target.src = process.env.PUBLIC_URL + "/images/company/logo-login-app.png"; }} />
                                        </div>

                                        <div className="card-body" style={{padding: '1.5rem 1.5rem 1rem'}}>
                                            <div className="text-center py-2">
                                                <div className="mb-2"><i className="la la-ban" style={{ fontSize: '50px', color: '#dc3545' }}></i></div>
                                                <h4 className="mb-2 text-danger font-weight-bold">{this.state.title}</h4>
                                                <p className="text-muted" style={{fontSize: '14px'}}>{this.state.text}</p>
                                                <hr className="my-3" />
                                                <small className="text-muted">Por favor, contacte a su Ejecutivo de Cuentas.</small>
                                            </div>

                                            <div className="mt-3 pt-3" style={{borderTop: '1px solid #f3f3f3'}}>
                                                <div className="row align-items-center">
                                                    <div className="col-6 text-left">
                                                        {logoCompanySrc && <img src={logoCompanySrc} alt="Company" className="img-fluid" style={{maxHeight: '40px', maxWidth: '100%', objectFit:'contain'}} onError={(e) => { e.target.onerror = null; e.target.src = process.env.PUBLIC_URL + "/images/company/logo-login-company.png"; }} />}
                                                    </div>
                                                    <div className="col-6 text-right">
                                                        {logoPoweredBySrc && <img src={logoPoweredBySrc} alt="Powered By" className="img-fluid" style={{maxHeight: '35px', maxWidth: '100%', objectFit:'contain'}} onError={(e) => { e.target.onerror = null; e.target.src = process.env.PUBLIC_URL + "/images/company/logo-login-powered-by.png"; }} />}
                                                    </div>
                                                </div>
                                                <div className="text-center mt-3">
                                                    <span style={{ display: 'inline-block', fontWeight: '500', fontSize: '11px', padding: '5px 12px', color: '#6c757d', backgroundColor: '#ffffff', border: '1px solid #e0e0e0', borderRadius: '20px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
                                                        v{shortVersion}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        );
    }
}
export default Suspension;
